/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BasisOfCoverResponseDto,
  ErrorResponse,
  UpsertBasisOfCoverPayloadDto,
} from '../models/index';
import {
    BasisOfCoverResponseDtoFromJSON,
    BasisOfCoverResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    UpsertBasisOfCoverPayloadDtoFromJSON,
    UpsertBasisOfCoverPayloadDtoToJSON,
} from '../models/index';

export interface GetBasisOfCoversRequest {
    submissionId: string;
}

export interface UpsertBasisOfCoversRequest {
    submissionId: string;
    upsertBasisOfCoverPayloadDto: Array<UpsertBasisOfCoverPayloadDto>;
}

/**
 * 
 */
export class BasisOfCoverApi extends runtime.BaseAPI {

    /**
     * Get basis of covers
     */
    async getBasisOfCoversRaw(requestParameters: GetBasisOfCoversRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BasisOfCoverResponseDto>>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling getBasisOfCovers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/submission/{submissionId}/basis-of-cover`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BasisOfCoverResponseDtoFromJSON));
    }

    /**
     * Get basis of covers
     */
    async getBasisOfCovers(requestParameters: GetBasisOfCoversRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BasisOfCoverResponseDto>> {
        const response = await this.getBasisOfCoversRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upsert basis of covers
     */
    async upsertBasisOfCoversRaw(requestParameters: UpsertBasisOfCoversRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BasisOfCoverResponseDto>>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling upsertBasisOfCovers().'
            );
        }

        if (requestParameters['upsertBasisOfCoverPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'upsertBasisOfCoverPayloadDto',
                'Required parameter "upsertBasisOfCoverPayloadDto" was null or undefined when calling upsertBasisOfCovers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/submission/{submissionId}/basis-of-cover`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['upsertBasisOfCoverPayloadDto']!.map(UpsertBasisOfCoverPayloadDtoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BasisOfCoverResponseDtoFromJSON));
    }

    /**
     * Upsert basis of covers
     */
    async upsertBasisOfCovers(requestParameters: UpsertBasisOfCoversRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BasisOfCoverResponseDto>> {
        const response = await this.upsertBasisOfCoversRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
